<div class="answerbox-show mt-4 border border-radius-10 p-3">
    <h3 class="heading-avbold">Your Answer:</h3>
    <div class="add-post-inputbox2">
        <!-- <textarea id="comment-box-{{commentId}}" class="form-control" formControlName="forumComment" placeholder="Enter here..." rows="7" spellcheck="false" ></textarea> -->

        <div [formGroup]="comment_form">
          <div class="form-group">
            <textarea id="comment-box-{{commentId}}" class="form-control" formControlName="comment" placeholder="Enter here..." rows="7" spellcheck="false" ></textarea>
            <span class="text-danger" *ngIf="comment_form.controls['comment'].hasError('required') && (comment_form.controls['comment'].dirty || comment_form.controls['comment'].touched)">Answer is required</span>
          </div>
        </div>

        <div class="row mt-3">
            <!-- <div class="col-md-8">
                <ul class="list-inline  mb-0 d-flex align-items-center h-100">
                    <li class="list-inline-item mr-4">
                        <a href="#" class="text-dark"><img src="assets/images/attachment-icon.svg" alt="attachment" class="mr-2"> Attach Photo</a>
                    </li>
                    <li class="list-inline-item">
                        <a href="#" class="text-dark"><img src="assets/images/scan-doc-icon.svg" alt="attachment" class="mr-2"> Scan Document</a>
                    </li>
                </ul>
            </div> -->

              <div class="col-md-8">
                <ng-container *ngIf="!hideAttachment">
                  <ul class="list-inline  mb-0 d-flex align-items-center h-100">
                      <li class="list-inline-item">
                          <input type="file" (change)="fileChangeEventUpload($event.target.files)" style="display:none;" #fileUpload>
                          <div class="text-dark" style="cursor: pointer;" (click)="fileUpload.click()">
                            <img src="assets/images/attachment-icon.svg" alt="attachment" class="mr-2">
                            Attach Photo
                          </div>
                          <div *ngIf="fileName" class="outer-file">
                            <div *ngIf="imageSrc" style="width: 50px; height: 50px;" class="pr-2">
                              <img [src]="imageSrc" style="object-fit: contain; width: 100%; height: 100%;">
                            </div>
                            <div class="upload-file-name">{{fileName}}</div>
                          <div class="remove-icon"><i class="fa fa-remove" style="font-size:24px;color:red" (click)="removeFile()"></i></div>
                          </div>
                          <div *ngIf="showSupportText">
                            <span class="text-warning">{{supportText}}</span>
                          </div>
                      </li>
                      <!-- <li class="list-inline-item">
                          <a href="#" class="text-dark"><img src="assets/images/scan-doc-icon.svg" alt="attachment" class="mr-2"> Scan Document</a>
                      </li> -->
                  </ul>
              </ng-container>
            </div>

            <div class="col-md-4 text-right">
                <button class="btn btn-pink-gradiant btn-next w-auto" (click)="addComment()">Post Answer</button>
            </div>
        </div>
    </div>
</div>
